import { useState, useEffect } from "react";
import * as C from "../Customizing.styles";
import CustomInput from "../thirdStepEl/input";
import CustomImgSelect from "../thirdStepEl/imgSelect";
import CustomPrint from "../thirdStepEl/print";
import CustomSelect from "../thirdStepEl/select";
import { useFormContext } from "react-hook-form";
import { downloadsAPI } from "@/api/downloads";
import { fileDownloadHelper } from "@/common/files";
import CustomRadio from "../thirdStepEl/radio";
import CustomText from "../thirdStepEl/text";

const ProductDetail = ({
  detailData,
  category,
  onChangeUserInputs,
  directConfirm,
  isUser,
  cnt,
  cntError,
  setIntroductions,
  modalContents,
  setModalContents,
}) => {
  const { register, formState, watch, reset, getValues } = useFormContext();

  const openModal = (i, el) => () => {
    setModalContents({
      ...modalContents,
      show: true,
      image: el.image,
      title: el.title,
    });
  };

  // row Type Checking
  const typeChecking = (data) => {
    if (data.type === "I") {
      return (
        <CustomInput
          title={data.name}
          code={data.code}
          onChangeUserInputs={onChangeUserInputs}
          register={register}
          formState={formState}
          cntError={cntError}
          cnt={cnt}
          watch={watch}
        />
      );
    }
    if (data.type === "S") {
      return (
        <CustomSelect
          title={data.name}
          code={data.code}
          options={data.options}
          register={register}
          formState={formState}
          watch={watch}
          getValues={getValues}
          detailData={detailData}
        />
      );
    }
    if (data.type === "M") {
      return (
        <CustomPrint
          title={data.name}
          code={data.code}
          options={data.options}
          openModal={openModal}
          register={register}
          reset={reset}
          formState={formState}
          watch={watch}
          getValues={getValues}
          detailData={detailData}
        />
      );
    }
    if (data.type === "D") {
      return (
        <CustomImgSelect
          title={data.name}
          code={data.code}
          options={data.options}
          openModal={openModal}
          register={register}
          formState={formState}
          reset={reset}
          getValues={getValues}
          watch={watch}
          detailData={detailData}
          category={category}
        />
      );
    }
    if (data.type === "R") {
      if (watch(data.code) == undefined) {
        setTimeout(() => {
          reset({ ...watch(), [data.code]: data.options[1].okey });
        }, 200);
      }
      return (
        <CustomRadio
          title={data.name}
          code={data.code}
          options={data.options}
          openModal={openModal}
          register={register}
          formState={formState}
          reset={reset}
          getValues={getValues}
          watch={watch}
          detailData={detailData}
        />
      );
    }
    if (data.type === "T") {
      return (
        <CustomText
          title={data.name}
          code={data.code}
          options={data.options}
          openModal={openModal}
          register={register}
          formState={formState}
          reset={reset}
          getValues={getValues}
          watch={watch}
          detailData={detailData}
        />
      );
    }
  };

  // 칼선 다운로드
  const printDownload = async (code) => {
    const body = {
      modes: "ListSet",
    };
    const res = await downloadsAPI(body);
    if (res.Code === "0000") {
      if (code === "M0039") {
        const url = res?.Data?.Data?.packaging.find(
          (el) => el.code === "F1084"
        ).url;
        fileDownloadHelper(url);
      }
    } else {
      failAlert(res?.Data?.Msg || res);
      console.error(res.Data?.Msg);
    }
  };

  const fetchIntroductions = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await downloadsAPI(body);
    if (res.Code === "0000") {
      setIntroductions(res?.Data?.Data?.introduction);
    } else {
      setIntroductions([]);
      console.error(res.Data?.Msg);
    }
  };

  useEffect(() => {
    if (category?.code === "M0039") {
      fetchIntroductions();
    }
    reset({});
  }, [detailData]);

  return (
    <>
      <C.ContentWrapper>
        <C.ContentBox>
          <C.ContentBoxTitle>제작 수량</C.ContentBoxTitle>
          <div className="cnt_box">
            <CustomInput
              title={"수량"}
              code={"cnt"}
              onChangeUserInputs={onChangeUserInputs}
              register={register}
              cntError={cntError}
              cnt={cnt}
              readOnly={category?.code === "M0039"}
            />
          </div>
        </C.ContentBox>
        {detailData.Row?.length > 0 &&
          detailData.Row?.map((el, i) => (
            <C.ContentBox key={i}>
              <C.ContentBoxTitle>
                {el.title}
                {el.image && el.image !== "" && (
                  <span className="size_info" onClick={openModal(i, el)}>
                    상세가이드 보기
                  </span>
                )}
              </C.ContentBoxTitle>

              <C.BoxItem
                row={
                  el.data.length > 0 &&
                  el.data
                    .map((el) => el.type !== "I" && el.type !== "R")
                    .includes(false)
                }
                grid={!el.data.map((el) => el.type == "R").includes(false)}
                className={
                  !el.data.map((el) => el.type == "R").includes(false) &&
                  "radios"
                }
              >
                {el.data.map((data, dataIndex) => (
                  <div key={dataIndex} style={{ width: "100%" }}>
                    {data.code === "T0006" && category?.code === "M0039" && (
                      <div
                        className="print_download"
                        onClick={() => printDownload(category?.code)}
                      >
                        도안 다운로드
                      </div>
                    )}
                    {typeChecking(data)}
                  </div>
                ))}
              </C.BoxItem>
            </C.ContentBox>
          ))}
        <C.BtnWrapper>
          {isUser && (
            <button className="btn btn-md btn-secondary" type="submit">
              견적 바구니에 담기
            </button>
          )}
          <button className="btn btn-md" onClick={directConfirm} type="button">
            바로 견적 요청
          </button>
        </C.BtnWrapper>
      </C.ContentWrapper>
    </>
  );
};
export default ProductDetail;
